import socket from 'socket';

let socketPath = window.PAGE_DATA.commonData.socketPath || "43.242.84.27:8081";

function getSocket() {
    // ws://socket.forex.com.cn/socket/userCenterSymbolPrice/null
    return socket.websocket(socketPath.market);

};

function getAccountInfo(userId) {
    // ws://socket.forex.com.cn/socket/userCenter
    return socket.websocket(socketPath.order, userId);
};

function getSymbolList() {
    return socket.websocket("ws://"+socketPath+"/SymbolPrice");
}


module.exports = {
	getSocket:getSocket,
    getAccountInfo:getAccountInfo,
    getSymbolList: getSymbolList
}



// WEBPACK FOOTER //
// ./src/service/common/currency.socket.js